
    const addAllButtons = document.querySelectorAll('.add_all');
    addAllButtons.forEach(addAll => {
        addAll.addEventListener('click', function (e) {
            e.target.querySelector('.loader').style.display = 'block'
            const formData = { items: [] };
            const parent = e.target.closest('.shop-the-look-block');
            parent.querySelectorAll('.shop-the-look-popup-products-list .grid__item:not(:first-child) .product-thumbnail')
                .forEach(item => {
                    const productId = item.getAttribute('data-id');
                    if (productId) {
                        formData.items.push({
                            id: productId,
                            quantity: 1
                        });
                    }
                });
            console.log(formData)
            if (formData.items.length > 0) {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
                    $(this).parents('.shop-the-look-popup').find('.product-form__buttons button').click();
                    setTimeout(() => {
                        e.target.querySelector('.loader').style.display = 'none'
                    },1000)
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            } else {
                console.log('No products found to add.');
            }
        });
    });
   
    $('.shop-the-look-main-image').click(function(){
        $(this).next('.shop-the-look-popup').fadeIn();
        $('body').addClass('o-hidden');
    })
    $('.shop_the_look_close').click(function(){
        $(this).parents('.shop-the-look-block').find('.shop-the-look-popup').fadeOut();
        $('body').removeClass('o-hidden');
    })
